import type {HeroData} from './types';

export const heroData: HeroData = {
    content: {
        title: [
            'life begins then',
            'when color is added to it',
        ],
        sectionLabel: 'our collection',
        buttonLabel: 'find out more',
        buttonTo: '/catalog',
    }
};